interface ChangesIndicatorProps {
  hasChanges: boolean;
  planOutput?: string;
  environment: string;
  appName: string;
  hasPlan: boolean; // Whether a plan exists for this version
  onClick?: () => void; // Click handler to open plan dialog
}

export const ChangesIndicator = ({
  hasChanges,
  planOutput,
  environment,
  appName,
  hasPlan,
  onClick,
}: ChangesIndicatorProps) => {
  const handleClick = () => {
    if (onClick) {
      onClick();
    } else if (planOutput) {
      console.log(`Plan output for ${appName} (${environment}):`);
      console.log(planOutput);
    } else {
      console.log(`No plan output available for ${appName} (${environment})`);
    }
  };

  // Determine color based on state
  let colorClasses: string;
  let backgroundColor: string | undefined;
  let label: string;
  let title: string;

  if (!hasPlan) {
    // No plan result yet - greyed out
    colorClasses = 'border-gray-300 bg-gray-100 text-gray-400';
    label = 'Not scanned';
    title = 'No plan result available yet - waiting for scan';
  } else if (hasChanges) {
    // Has changes - yellow
    colorClasses = 'text-white';
    backgroundColor = 'rgb(237,187,106)';
    label = 'Deployment required';
    title = 'Click to view plan details';
  } else {
    // No changes - same color as successful deployments
    colorClasses = 'text-white';
    backgroundColor = '#244554';
    label = 'Up to date';
    title = 'Click to view plan details';
  }

  return (
    <button
      onClick={handleClick}
      className={`-ml-3 relative flex h-16 items-center justify-center pl-8 pr-6 text-xs font-medium transition-colors hover:opacity-80 flex-shrink-0 ${colorClasses}`}
      style={{
        clipPath: 'polygon(0% 0%, 100% 0%, 100% 100%, 0% 100%, 20px 50%)',
        width: '140px',
        backgroundColor: backgroundColor || undefined,
      }}
      title={title}
    >
      <span className='relative z-10'>{label}</span>
    </button>
  );
};
